import styled from 'styled-components';

const GenericSectionContainer = styled.div`
  padding-top: ${p => p.theme.unit(p.top)};
  padding-bottom: ${p => p.theme.unit(p.bottom)};
`;

export default GenericSectionContainer;
